import { createStyles, TableHead, TableRow, Theme, withStyles, WithStyles } from '@material-ui/core'
import { blue } from '@material-ui/core/colors'
import * as React from 'react'

import { Sort } from '../../../services/sortingService'
import { TableHeader } from '../../TableWrapper'
import CustomTableCell from '../TableCell/TableCell'

interface TableHeaderProps extends WithStyles<typeof styles> {
	sortBy: string
	sortDirection: Sort
	handleSortClick: (currentOrder: Sort, sortLabel: string) => (event: React.MouseEvent<HTMLElement>) => void
	headers: TableHeader[]
}

export const CustomTableHeader: React.FC<TableHeaderProps> = (props: TableHeaderProps) => {
	const { classes, handleSortClick, headers, sortBy, sortDirection } = props
	const headersLen = headers.length;

	return (
		<TableHead component="div" className={classes.tableHeader} data-auto="main-table-header">
			<TableRow component="div" className={classes.tableRow}>
				{headers.map((header: TableHeader, index: number) => {
					const { label, prop } = header
					if (headersLen === index + 1) {
						return (
							<CustomTableCell
								key={index}
								sortBy={sortBy}
								sortDirection={sortDirection}
								handleSortClick={handleSortClick}
								prop={prop}
								label={label}
								cellProps={{align: 'right'}}
							/>
						)
					} else {
						return (
							<CustomTableCell
								key={index}
								sortBy={sortBy}
								sortDirection={sortDirection}
								handleSortClick={handleSortClick}
								prop={prop}
								label={label}
							/>
						)
					}
				})}
			</TableRow>
		</TableHead>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		tableHeader: {
			backgroundColor: blue[900],
			paddingLeft: theme.spacing.unit,
			textTransform: 'uppercase',
		},
		tableRow: {
			flex: '1 1 100%',
		},
		colHeader: {},
		colEmptyHeader: {
			width: '32px',
			padding: '0',
		},
	})

export default withStyles(styles)(CustomTableHeader)
